module.exports = __webpack_public_path__ + "img/A58A1337_min.b04d7ee1.jpg";